var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FilterBaseSelectBox',{staticClass:"filter-business-event-form",attrs:{"value":_vm.businessEventDefinitionId,"options":_vm.options,"prefix":_vm.$t('businessEventPrefix')},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }